import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProjectService} from '../../../shared/services/project/project.service';
import {StatesService} from '../../../shared/services/state/states.service';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {Project} from '../../../shared/classes/project/project';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs/index';
import {UserService} from '../../../shared/services/user/user.service';
import {MatStepper} from '@angular/material/stepper';


@Component({
  selector: 'app-project-crud',
  templateUrl: './project-crud.component.html',
  styleUrls: ['./project-crud.component.css']
})
export class ProjectCrudComponent implements OnInit, OnDestroy {


    public idProject: number = null;
    public selectedStep: number = null;
    public showSpinner: boolean;
    public project: Project = new Project();
    public projectForm: FormGroup;
    public projectAddressForm: FormGroup;
    public projectLocations: any[] = [];
    public reloadProjectCrud: Subscription;
    public levelSubscription: Subscription;
    public readOnly: boolean = true;
    @ViewChild('stepper') stepper: MatStepper;

  constructor(private projectService: ProjectService,
              private toastr: ToastrService,
              public statesService: StatesService,
              private userService: UserService,
              public authenticationService: AuthenticationService,
              private translate: TranslateService,
              private route: ActivatedRoute,
              private router: Router) {
  }


  ngOnInit() {
    this.readOnly = (this.router.url.indexOf('-view') !== -1);
    this.idProject = parseInt(this.route.snapshot.paramMap.get('idProject'));
    this.selectedStep = parseInt(this.route.snapshot.paramMap.get('selectedStep'));

    this.reloadProjectCrud = this.statesService.reloadProjectCrud
      .subscribe(() => this.initProject()
      );
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.router.navigate(['/projects'])
      );
    this.initProject();

  }

  ngOnDestroy() {
    this.reloadProjectCrud.unsubscribe();
    this.levelSubscription.unsubscribe();
  }

  saveProject() {
    this.setProjectWithForms();

    this.showSpinner = true;
    if (this.idProject) {
      this.projectService.patchProject(this.idProject, this.project)
        .subscribe(
          (data: any) => {
            this.setProject(data);
            this.toastr.success(this.translate.instant('PROJECT_MODIFIED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          }
          ,
          error2 => {
            this.showSpinner = false;
          }
        );
    } else {
      this.projectService.postProject(this.project)
        .subscribe((data: any) => {
            this.idProject = data.id;
            this.setProject(data);
            this.toastr.success(this.translate.instant('PROJECT_ADDED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          }
          ,
          error2 => {
            this.showSpinner = false;
          }
        );
    }
  }


  private initProject() {
    if (!isNaN(this.idProject)) {
      this.showSpinner = true;
      this.projectService.getProject(this.idProject)
        .subscribe(
          (data: any) => {
            this.setProject(data);
            this.showSpinner = false;

          },
          (error2) => {
            this.showSpinner = false;
          }
        );
    } else {
      this.idProject = null;
      this.setFormsWithProject();
    }
  }

  private setProject(data: any) {
    this.projectLocations = data.project_device_locations;
    this.project.setProject(data);
    this.setFormsWithProject();

  }

  private setProjectWithForms() {

    if (this.project.id) {
      delete this.project.level;
    } else {
      this.project.level = this.statesService.stateLevel;
    }
    delete this.project.id;
    delete this.project.project_device_locations_count;
    delete this.project.project_device_locations_gps_count;
    delete this.project.project_plans_count;
    this.project.name = this.projectForm.value.name;
    this.project.code = this.projectForm.value.code;
    this.project.description = this.projectForm.value.description;
    this.project.documentUrl = this.projectForm.value.document_url;
    this.project.startDate = this.projectForm.value.start_date;
    this.project.endDate = this.projectForm.value.end_date;
    this.project.active = this.projectForm.value.active;
    this.project.archive = this.projectForm.value.archive;

    this.project.latitude = this.projectAddressForm.value.latitude;
    this.project.longitude = this.projectAddressForm.value.longitude;
    this.project.zoom = this.projectAddressForm.value.zoom;

    this.project.address.place = this.projectAddressForm.value.place;
    this.project.address.street = this.projectAddressForm.value.street;
    this.project.address.supplement = this.projectAddressForm.value.supplement;
    this.project.address.zipcode = this.projectAddressForm.value.zipcode;
    this.project.address.city = this.projectAddressForm.value.city;
    this.project.address.country = this.projectAddressForm.value.country;


  }

  private formatDate(date): string {
    let formatTime = (value: number) => value < 10 ? '0' + value.toString() : value;
    return `${formatTime(date.getFullYear())}-${formatTime(date.getMonth() + 1)}-${formatTime(date.getDate())} ${formatTime(date.getHours())}:${formatTime(date.getMinutes())}:${formatTime(date.getSeconds())}`;
  }

  private setFormsWithProject() {
    this.projectForm = new FormGroup({
      name: new FormControl(this.project.name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
      code: new FormControl(this.project.code, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      description: new FormControl(this.project.description, [Validators.maxLength(2048)]),
      document_url: new FormControl(this.project.documentUrl, [Validators.maxLength(2048)]),
      start_date: new FormControl(this.project.startDate, [Validators.required]),
      end_date: new FormControl(this.project.endDate, [Validators.required]),
      active: new FormControl(this.project.active),
      archive: new FormControl(this.project.archive),
    });

    this.projectAddressForm = new FormGroup({
      place: new FormControl(this.project.address.place),
      street: new FormControl(this.project.address.street),
      supplement: new FormControl(this.project.address.supplement),
      zipcode: new FormControl(this.project.address.zipcode),
      city: new FormControl(this.project.address.city),
      country: new FormControl(this.project.address.country),
      latitude: new FormControl(this.project.latitude),
      longitude: new FormControl(this.project.longitude),
      zoom: new FormControl(this.project.zoom),

    });
  }
}
